import React, { useEffect, useRef } from "react";

const About = () => {
  const scrollContainerRef = useRef(null);
  const images = [
    '/assets/images/Eth.svg', // Ethereum
    '/assets/images/Solana.svg' // Solana
  ];
  useEffect(() => {
    const scrollContent = scrollContainerRef.current;
    // Clone the content for seamless scrolling
    const clonedContent = scrollContent.cloneNode(true);
    scrollContent.appendChild(clonedContent);
  }, []);
  return (
    <div id="about">
      <div className="about pt-5 pb-5" style={{ overflow: "hidden" }}>
        <div className="scroll-container" >
          <div className="scroll-content d-flex align-items-center gap-3" ref={scrollContainerRef}>
          {Array.from({ length: 150 }).map((_, index) => (
          <img 
            key={index} 
            src={images[index % images.length]} 
            alt={index % 2 === 0 ? "Ethereum" : "Solana"} 
          />
        ))}
          </div>
        </div>
        <div className="container pt-5">
          <div className="row align-items-center">
            <div
              className="col-lg-6"
              data-aos="fade-right"
              data-aos-duration="1200"
            >
              <div className="about-glb">

              {/* <img
                className="w-100"
                src="/assets/images/about-cap.svg"
                alt=""
                /> */}
                 <model-viewer
          camera-controls
          auto-rotate
          alt="3D Model"
          src="/assets/Capsule.glb"
          // style={{ width: "126px", height: "143px" }}
          onError={() =>
            console.error(
              "Failed to load the model. Check the file path or model format."
            )
          }
        ></model-viewer>
                </div>
            </div>
            <div
              className="col-lg-6"
              data-aos="fade-left"
              data-aos-duration="1200"
            >
              <h2>About Pharma Trades</h2>
              <p>
                Pharma Trades is a cutting-edge platform designed to facilitate
                Over-The-Counter (OTC) trading of cryptocurrencies and tokens on
                the Ethereum and Solana blockchains.
              </p>
              <h2 className="pt-4">Mission</h2>
              <p className="pb-4">
                Our mission is to provide a secure, efficient, and user-friendly
                environment for executing OTC deals, leveraging advanced smart
                contract technology and our native PHARMA token.
              </p>
              <p>
                Whether you're a seasoned trader or new to the crypto space,
                Pharma Trades offers the tools and support you need to conduct
                large-scale trades with confidence and ease.
              </p>
              <div className="animate-3" style={{bottom:'-50px !important'}}>
                <img src="/assets/images/animate-2.svg" alt="capsule-1" />
              </div>
            </div>
          
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
